module.exports = __webpack_public_path__ + "static/distributed-global-9c8bb0d8c3ab33ae0a84e20a1d08198e.svg";